var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bf32c77f3cafd0cb5a4571679636576ee147abcd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lildog@lilbit"]={id:"bf32c77f3cafd0cb5a4571679636576ee147abcd"};
      